<template>
  <div class="flex" :class="sizes[props.size]">
    <component class="w-full h-full" :is="icons[props.name]" />
  </div>
</template>

<script setup>
import question from "@/components/icons/question.vue";
import circleClose from "@/components/icons/circleClose.vue";
import circleMore from "@/components/icons/circleMore.vue";
import plus from "@/components/icons/plus.vue";
import more from "@/components/icons/more.vue";
import replay from "@/components/icons/replay.vue";
import cornerRightUp from "@/components/icons/cornerRightUp.vue";
import arrowChevron from "@/components/icons/arrowChevron.vue";
import qrScan from "@/components/icons/qrScan.vue";
import swap from "@/components/icons/swap.vue";
import bankCardSend from "@/components/icons/bankCardSend.vue";
import walletIncome from "@/components/icons/walletIncome.vue";
import coinSwap from "@/components/icons/coinSwap.vue";
import arrowShare from "@/components/icons/arrowShare.vue";
import copy from "@/components/icons/copy.vue";
import documentAnalyze from "@/components/icons/documentAnalyze.vue";
import usd from "@/components/icons/usd.vue";
import swapHorizontal from "@/components/icons/swapHorizontal.vue";
import info from "@/components/icons/info.vue";
import checkBadge from "@/components/icons/checkBadge.vue";
import check from "@/components/icons/check.vue";
import close from "@/components/icons/close.vue";
import eye from "@/components/icons/eye.vue";
import google from "@/components/icons/google.vue";
import shield from "@/components/icons/shield.vue";
import appleDownload from "@/components/icons/apple-download.vue";
import googleDownload from "@/components/icons/google-download.vue";
import arrowGrayRight from "@/components/icons/arrowGrayRight.vue";
import dollar from "@/components/icons/dollar.vue";
import wind from "@/components/icons/wind.vue";
import newTab from "@/components/icons/newTab.vue";
import document from "@/components/icons/document.vue";
import profile from "@/components/icons/profile.vue";
import arrow from "@/components/icons/arrow.vue";
import arrowSwap from "@/components/icons/arrowSwap.vue";
import verifyShield from "@/components/icons/verifyShield.vue";
import verifyBadge from "@/components/icons/verifyBadge.vue";
import apple from "@/components/icons/apple.vue";
import play from "@/components/icons/play.vue";
import date from "@/components/icons/date.vue";
import chat from "@/components/icons/chat.vue";
import message from "@/components/icons/message.vue";
import attach from "@/components/icons/attach.vue";
import pencil from "@/components/icons/pencil.vue";
import arrowPlay from "@/components/icons/arrowPlay.vue";
import trash from "@/components/icons/trash.vue";
import pause from "@/components/icons/pause.vue";
import circlePlus from "@/components/icons/circlePlus.vue";
import coinhold from "@/components/icons/coinhold.vue";
import chess from "@/components/icons/chess.vue";
import tonPoker from "@/components/icons/tonPoker.vue";
import history from "@/components/icons/history.vue";
import telegram from "@/components/icons/telegram.vue";
import setting from "@/components/icons/setting.vue";
import heartRate from "@/components/icons/heartRate.vue";
import phoneLike from "@/components/icons/phone-like.vue";
import faceId from "@/components/icons/face-id.vue";
import statusError from "@/components/icons/status-error.vue";
import orderUser from "@/components/icons/orderUser.vue";
import orderDocument from "@/components/icons/orderDocument.vue";
import orderChat from "@/components/icons/orderChat.vue";
import icCornerSmallDown from "@/components/icons/icCornerSmallDown.vue";
import smblStatusSuccess from "@/components/icons/smblStatusSuccess.vue";
import smblStatusSuccessGray from "@/components/icons/smblStatusSuccessGray.vue";
import orderSuccessGreen from "@/components/icons/orderSuccessGreen.vue";
import arrowGrayTop from "@/components/icons/arrowGrayTop.vue";
import chatEmpty from "@/components/icons/chatEmpty.vue";
import send from "@/components/icons/send.vue";
import icChatSmall from "@/components/icons/icChatSmall.vue";
import arrowLeft from "@/components/icons/arrowLeft.vue";
import giftCards from "@/components/icons/giftCards.vue";
import giftCardsCopy from "@/components/icons/gift-cards/copy.vue";
import errorPageCross from "@/components/icons/gift-cards/errorPageCross.vue";
import topup from "@/components/icons/topup.vue";
import safe from "@/components/icons/safe.vue";
import shield2 from "@/components/icons/shield2.vue";
import income from "@/components/icons/income.vue";
import icInfoSmall from "@/components/icons/icInfoSmall.vue";
import welcomePlay from "@/components/icons/welcome-play.vue";
import welcomePause from "@/components/icons/welcome-pause.vue";
import welcomeUnpause from "@/components/icons/welcome-unpause.vue";
import welcomeMute from "@/components/icons/welcome-mute.vue";
import welcomeUnmute from "@/components/icons/welcome-unmute.vue";
import welcomeRestart from "@/components/icons/welcome-restart.vue";
import welcomeClose from "@/components/icons/welcome-close.vue";
import icGiftDynamic from "@/components/icons/icGiftDynamic.vue";
import copyBrand from "@/components/icons/copyBrand.vue";
import goToExplorer from "@/components/icons/goToExplorer.vue";
import renewal from "@/components/icons/renewal.vue";
import tuning from "@/components/icons/tuning.vue";
import autoTopup from "@/components/icons/auto-topup.vue";
import kebabMenu from "@/components/icons/kebab-menu.vue";
import miningReferral from "@/components/icons/mining-referral.vue";
import percentReferral from "@/components/icons/percent-referral.vue";
import indeskReferral from "@/components/icons/indesk-referral.vue";
import p2pReferral from "@/components/icons/p2p-referral.vue";
import coinholdReferral from "@/components/icons/coinhold-referral.vue";
import goToReferralFaq from "@/components/icons/goToReferralFaq.vue";
import refCopy from "@/components/icons/refCopy.vue";
import calculator from "@/components/icons/calculator.vue";
import filters from "@/components/icons/filters.vue";
import coins from "@/components/icons/coins.vue";

const icons = {
  topup,
  question,
  circleClose,
  circleMore,
  plus,
  more,
  replay,
  cornerRightUp,
  arrowChevron,
  qrScan,
  swap,
  bankCardSend,
  walletIncome,
  coinSwap,
  arrowShare,
  copy,
  documentAnalyze,
  usd,
  swapHorizontal,
  info,
  checkBadge,
  check,
  close,
  eye,
  google,
  shield,
  dollar,
  wind,
  newTab,
  document,
  profile,
  arrow,
  arrowSwap,
  arrowGrayRight,
  verifyShield,
  verifyBadge,
  apple,
  appleDownload,
  googleDownload,
  play,
  date,
  chat,
  message,
  attach,
  pencil,
  arrowPlay,
  trash,
  pause,
  circlePlus,
  coinhold,
  chess,
  tonPoker,
  giftCards,
  history,
  telegram,
  setting,
  heartRate,
  phoneLike,
  faceId,
  statusError,
  orderUser,
  orderDocument,
  orderChat,
  icCornerSmallDown,
  smblStatusSuccess,
  smblStatusSuccessGray,
  orderSuccessGreen,
  arrowGrayTop,
  chatEmpty,
  send,
  icChatSmall,
  arrowLeft,
  giftCardsCopy,
  errorPageCross,
  safe,
  shield2,
  income,
  icInfoSmall,
  welcomePlay,
  welcomePause,
  welcomeUnpause,
  welcomeMute,
  welcomeUnmute,
  welcomeRestart,
  welcomeClose,
  icGiftDynamic,
  copyBrand,
  goToExplorer,
  renewal,
  tuning,
  autoTopup,
  kebabMenu,
  miningReferral,
  percentReferral,
  indeskReferral,
  p2pReferral,
  coinholdReferral,
  goToReferralFaq,
  refCopy,
  calculator,
  filters,
  coins,
};

const props = defineProps({
  name: {
    type: String,
    default: "question",
  },
  size: {
    type: String,
  },
});

const sizes = {
  sm: "w-4 h-4",
  lg: " w-6 h-6",
};
</script>
